import './DashboardLink.css';

import React, { useState } from 'react';
import { generateClassName } from '../../b2b-common/helpers';
import { Dashboard } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const DashboardLink = ({ dashboard, className = null }) => {

    const [currentDashboard, setCurrentDashboard] = useState(dashboard);

    const navigate = useNavigate();

    const handleClick = () => {
        navigate(`/reporting/dashboards/${currentDashboard.dashboardId}`);
        // console.log('DashboardLink clicked');
    };

    return (
        <div className={generateClassName('dashboard-link', '-container', className)}
            onClick={handleClick}
        >
            <div className={generateClassName('dashboard-link', '-icon')}>
                <Dashboard />
            </div>
            <div className={generateClassName('dashboard-link', '-name')}>
                {currentDashboard.dashboardName}
            </div>
        </div>
    );
};

export default DashboardLink;